// Languages an astrologer can consult in (multi-select).
export const LANGUAGE_OPTIONS = ['國語', '粵語', '英文'];
